import zipUrls from "./zip-urls";
import "./download-media-status";

class DownloadMedia extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (e) => {
      const downloadButton = e.target.closest('[data-download]');
      if (downloadButton) {
        this._downloadSelected();
      };

      const selectButton = e.target.closest('[data-select]');

      if (selectButton) {
        this._select(selectButton.dataset.select);
      }
    });

    this.addEventListener('change', () => this._updateDownloadCount());
  }

  connectedCallback() {
    this._updateDownloadCount();
  }

  disconnectedCallback() {

  }

  _downloadSelected() {
    const downloadButton = this.querySelector('[data-download]');
    downloadButton.disabled = true;

    const urls = [...this.querySelectorAll('[data-download-checkbox]:checked')].map(el => {
      const a = el.parentElement.querySelector('a')

      return {
        url: a.href,
        filename: a.dataset.filename || `${this.dataset.filename}-${window.crypto.randomUUID()}`,
      }
    });

    zipUrls(urls).then(blob => {
      const blobUrl = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = `${this.dataset.filename}.zip`;
      a.click();
      downloadButton.disabled = false;

      URL.revokeObjectURL(blobUrl);
    })
      .catch((e) => {
        console.warn(e);
        this._setError('Something went wrong');
        downloadButton.disabled = false;
      });
  }

  _select(select) {
    this.querySelectorAll('[data-download-checkbox]').forEach(el => { el.checked = select !== 'none'; });
    this._updateDownloadCount();
  }

  _updateDownloadCount() {
    const selectedCount = this.querySelectorAll('[data-download-checkbox]:checked').length;
    const downloadButton = this.querySelector('[data-download]');
    if (selectedCount === 0) {
      downloadButton.disabled = true;
      downloadButton.innerHTML = downloadButton.dataset.disabled;
      return;
    }
    downloadButton.disabled = false;
    const text = selectedCount === 1 ? downloadButton.dataset.one : downloadButton.dataset.other.replace('[count]', selectedCount);
    downloadButton.innerHTML = text;
  }

  _setError(error) {
    const errorEl = this.querySelector('[data-error]');
    errorEl.innerHTML = error;
    errorEl.style.display = null;

    setTimeout(() => {
      errorEl.style.display = 'none';
    }, 3000);
  }
}

if (!customElements.get("download-media")) {
  customElements.define("download-media", DownloadMedia);
}
